import { Navigate, Route, Routes } from "react-router-dom";
import SentList from "./SentList";

/**
 * Trasy korzenia „Akceptacja i Podpis".
 * - Otrzymane / Do wiadomości reużywają komponentu Przychodzące (MessagesModule)
 *   przez trasę /packages/:filterId/incoming — nawigacja w SidebarFilter.
 * - Wysłane to lista typu grid (SentList).
 */
const AcceptanceSignRoute = () => {
  return (
    <Routes>
      <Route path="/sent" element={<SentList />} />
      <Route path="/*" element={<Navigate to="sent" replace />} />
    </Routes>
  );
};

export default AcceptanceSignRoute;
